import { Sparkles } from "lucide-react";

/**
 * ServiceCardSkeleton — luxury shimmer placeholder shown while /api/services loads.
 * Mirrors the real service card's dimensions (aspect-[16/9] image + compact body)
 * so the layout doesn't jump when data arrives.
 */
export function ServiceCardSkeleton() {
    return (
        <div className="card-luxe grain flex flex-col overflow-hidden" aria-hidden data-testid="service-skeleton">
            <div className="aspect-[16/9] bg-gradient-to-br from-[#FDF0EC] via-[#F7E4DE] to-[#FDF0EC] relative overflow-hidden">
                <div className="absolute inset-0 tresses-shimmer" />
            </div>
            <div className="p-3 flex-1 flex flex-col gap-2">
                <div className="h-4 w-3/4 bg-[#6B1535]/5 relative overflow-hidden"><div className="absolute inset-0 tresses-shimmer" /></div>
                <div className="h-3 w-full bg-[#6B1535]/5 relative overflow-hidden"><div className="absolute inset-0 tresses-shimmer" /></div>
                <div className="h-3 w-2/3 bg-[#6B1535]/5 relative overflow-hidden"><div className="absolute inset-0 tresses-shimmer" /></div>
                <div className="flex justify-between mt-2 pt-2 border-t border-[#6B1535]/10">
                    <div className="h-3 w-12 bg-[#6B1535]/5 relative overflow-hidden"><div className="absolute inset-0 tresses-shimmer" /></div>
                    <div className="h-3 w-16 bg-[#6B1535]/5 relative overflow-hidden"><div className="absolute inset-0 tresses-shimmer" /></div>
                </div>
            </div>
        </div>
    );
}

/**
 * Full-page loading state used when a section has nothing yet.
 * Renders `count` skeleton cards in the same grid as the real content.
 */
export function ServiceGridLoading({ count = 8, headline = "Curating your experience" }) {
    return (
        <div className="space-y-6" data-testid="services-loading">
            <div className="flex items-center gap-3 text-[0.65rem] tracking-[0.22em] uppercase text-[#8F622C]">
                <Sparkles size={12} className="animate-pulse" />
                <span>{headline}</span>
                <span className="text-[#8A6574] normal-case tracking-normal text-xs">— polishing our finest just for you.</span>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {Array.from({ length: count }).map((_, i) => (
                    <ServiceCardSkeleton key={i} />
                ))}
            </div>
        </div>
    );
}
